import { Dayts } from '@/utils';
import { ReactElement } from 'react';
import { UserModalTypes } from '@/pages/Users/components/UserModal/types';

const UserInfo = ({ createdAt, licenses, airports }: UserModalTypes.InfoProps): ReactElement => {
  return (
    <div className="UserModal-Info">
      <ul>
        {createdAt && (
          <li className="UserModal-Info-Name">
            <span>User Since</span>
            <strong>{`${new Dayts(createdAt).format('MMMM YYYY')}`}</strong>
          </li>
        )}
        {licenses?.length > 0 && (
          <li className="UserModal-Info-License">
            <strong>License:</strong>
            <strong>{`${licenses.at(0)?.number}`}</strong>
          </li>
        )}
        {airports?.length > 0 && (
          <li className="UserModal-Info-Airports">
            <span>Airports:</span>
            <span>{`${airports.join(', ')}`}</span>
          </li>
        )}
      </ul>
    </div>
  );
};

export default UserInfo;
